import {fetchAssociateMetrics} from "../network/AssociateNetworkAPI";

export const AssociatePerformanceReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {dispatcher} = action.data;
            fetchAssociateMetrics(dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/associate/reducers/AssociatePerformanceReducer.js